import { InboxNotificationDetailsResponse } from 'src/entities/Notifications';
import { API } from 'src/utils/AmplifyApiUtils';

interface NotificationsPageResponse {
  data?: InboxNotificationDetailsResponse[] | null;
  nextToken?: string;
}

interface LoadNotificationsPageOptions {
  nextToken?: string;
  limit?: number;
}

interface LoadRemainingNotificationsPagesOptions {
  nextToken?: string;
  limit?: number;
  onPageLoaded: (notifications: InboxNotificationDetailsResponse[]) => void;
}

export default class InboxClient {
  // Lowest-level notifications page fetch primitive. Higher-level callers
  // decide if they want a blocking full load or progressive hydration.
  static async loadNotificationsPage({
    nextToken,
    limit = 1000,
  }: LoadNotificationsPageOptions = {}): Promise<{
    notifications: InboxNotificationDetailsResponse[];
    nextToken: string | undefined;
  }> {
    const getNotificationsResponse: NotificationsPageResponse = await API.get(
      'AppAPI',
      `/notifications`,
      {
        queryStringParameters: {
          nextToken,
          limit,
        },
      },
    );

    return {
      notifications: getNotificationsResponse.data ?? [],
      nextToken: getNotificationsResponse.nextToken,
    };
  }

  // Iteratively fetches subsequent pages and streams each page to onPageLoaded.
  static async loadRemainingNotificationsPages({
    nextToken,
    limit = 1000,
    onPageLoaded,
  }: LoadRemainingNotificationsPagesOptions): Promise<void> {
    let currentNextToken = nextToken;
    while (currentNextToken) {
      const pageResponse = await this.loadNotificationsPage({
        nextToken: currentNextToken,
        limit,
      });

      if (pageResponse.notifications.length > 0) {
        onPageLoaded(pageResponse.notifications);
      }

      currentNextToken = pageResponse.nextToken;
    }
  }
}
